// Location data for the Christchurch deployment.
const RegionServiceChristchurch = {
  region: "christchurch",
  dataset: "Christchurch", // used for Silverrail API
  timetableDataset: "Christchurch", // used for Silverrail API for Timetables
  defaultSuburb: "Christchurch",
  contactNumber: "03 366 8855",
  exampleText: '"32 Riccarton Road" or "50501"',
  homepageRegion: "Greater Christchurch",
  navbarRegion: "Christchurch",
  timetableUrl:
    "http://www.metroinfo.co.nz/timetables/Pages/Timetable.aspx?routeid=",
  homepageUrl: "http://www.metroinfo.co.nz/",
  map: {
    lat: -43.5131367,
    lng: 172.5990772,
    zoom: 12,
    minZoom: 1
  },
  searchExtent: "172.194,-43.717,173.009,-43.183",
  preventSundays: false,
  boundingStops: 2,

  // 'We use Cartesian coordinates ... i.e. wrong part of the bounding box.'
  searchExtentRest: "172.194,-43.183,173.009,-43.717",

  // Issue #280: Allow for multiple route definitions based on date
  // Otherwise uses the "Default" route
  multipleRoutes: {
    "2014-12-08": "December"
  }
};

// Location data for the Timaru deployment.
const RegionServiceTimaru = {
  region: "timaru",
  dataset: "Christchurch", // used for Silverrail API,
  timetableDataset: "Timaru", // used for Silverrail API for Timetables
  defaultSuburb: "Timaru",
  contactNumber: "03 688 5544",
  exampleText: '"32 Wai-iti Rd" or "40429"',
  homepageRegion: "Timaru",
  navbarRegion: "Timaru",
  timetableUrl:
    "http://www.metroinfo.co.nz/timaru/timetables/Pages/Timetable.aspx?routeid=",
  homepageUrl: "http://www.metroinfo.co.nz/timaru/Pages/default.aspx",
  map: {
    lat: -44.39054462773062,
    lng: 171.23714805373126,
    zoom: 14,
    minZoom: 11
  },
  searchExtent: "171.189,-44.417,171.272,-44.272",
  preventSundays: true,
  boundingStops: 2,

  // 'We use Cartesian coordinates ... i.e. wrong part of the bounding box.'
  searchExtentRest: "171.189,-44.272,171.272,-44.417",

  // Issue #280: Allow for multiple route definitions based on date
  // Otherwise uses the "Default" route
  multipleRoutes: false
};

export { RegionServiceChristchurch, RegionServiceTimaru };
